import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

// 物业注册
export function wuyeRegister(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.wuyeRegisterStoreAndShop',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取商铺类型
export function listShopTypes(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopType.queryShopType',
      method: 'get',
      params: {
        ...params,
        _uId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取地区列表
export function listAreas(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/area.listAreas',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取我的店铺
export function listMyStore(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/store.listMyStore',
      method: 'get',
      params: {
        ...params,
        _uId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取我入驻的商铺
export function listMyEnteredShops(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.listMyEnteredShops',
      method: 'get',
      params: {
        ...params,
        _uId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询员工权限
export function queryStaffPrivileges(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilege.queryStaffPrivileges',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// PC端验证码登录
export function pcCodeUserLogin(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/login.pcCodeUserLogin',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}